export const useSxStyles = () => {
  return {
    root: {
      height: '100%',
    },
  };
};
